export enum EPopupLinkType {
  SAME_TAB = '내부 페이지 이동',
  NEW_TAB = '새창',
  NONE = '링크 없음',
}

export enum EPopupDisplayType {
  CENTER = '중앙 모달',
  BOTTOM = '하단 배너형',
  SIDE = '사이드 플로팅',
  FULL_SCREEN = '풀스크린',
}

export enum EPopupFrequency {
  ALWAYS = '매번',
  ONCE = '한번만',
  DAILY = '하루한번',
  CUSTOM_DAYS = 'N일간 안보기',
}

export enum PopupCategory {
  MAIN = 1,
  LMS = 2,
}

// 팝업 데이터 타입
export interface PopupItem {
  id: number;
  title: string;
  thumbnailUrl: string;
  contentHtml: string;
  linkUrl: string;
  linkType: keyof typeof EPopupLinkType;
  displayType: keyof typeof EPopupDisplayType;
  frequency: keyof typeof EPopupFrequency;
  frequencyDays: number;
  fromDate: string;
  toDate: string;
  isActive: boolean;
  priority: number;
  viewCount: number;
  clickCount: number;
  categories: {
    id: PopupCategory;
    name: keyof typeof PopupCategory;
  }[];
  imagePcUrl: string;
  imageMobileUrl: string;
  imagePcFileId: string;
  imageMobileFileId: string;
}
